import * as React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { CASH, CASH_CHANGER, CREDIT_CARD } from '@/models/payment-method'
import { UseFormReturn } from 'react-hook-form'
import { CardInfo } from '@/components/pages/self-checkin/payment/manual-payment-screen'
import { CreditCardForm } from './credit-card-form'
import { createSelfCheckinResponsiveStyle, FrontTabletResponsiveToken } from '@/utils/front-tablet-responsive-style'
export type Props = {
  selectedPaymentMethod: string | undefined
  paymentSetting: string[]
  onChangePaymentMethod: (data) => void
  cardForm: UseFormReturn<CardInfo, any>
}

export const CheckinPaymentMethod: React.FC<Props> = ({ selectedPaymentMethod, onChangePaymentMethod, paymentSetting, cardForm }) => {
  const { t } = useTranslation()
  const paymentMethodOptions = [
    { label: 'PayAtTheFrontDesk', value: CASH },
    { label: 'CashChanger', value: CASH_CHANGER },
    { label: 'CreditCardPayment', value: CREDIT_CARD },
  ]
  return (
    <div css={paymentWrapper}>
      <div css={paymentSelectWrapper}>
        <span css={labelStyle}>{t('Payment options')}</span>
        <select name="selectPaymentMethod" css={selectStyle} value={selectedPaymentMethod} onChange={onChangePaymentMethod}>
          {paymentMethodOptions
            .filter(opt => paymentSetting.includes(opt.value as any))
            .map(paymentMethod => (
              <option value={paymentMethod.value} key={paymentMethod.value}>
                {t(`SelfCheckinPayment.${paymentMethod.label}`)}
              </option>
            ))}
        </select>
      </div>
      {selectedPaymentMethod === CREDIT_CARD && <CreditCardForm cardForm={cardForm} />}
    </div>
  )
}

const paymentSelectWrapper = css({
  paddingBottom: '16px',
  // 他の見出し（ご請求金額など）と左端を揃えるため、左右32pxに統一
  padding: '0 32px 16px 32px',
})
const paymentWrapper = css(
  {
    width: '100%',
    backgroundColor: '#fff',
    textAlign: 'left',
    padding: '30px 0',
    borderRadius: '10px',
    marginTop: '16px',
  },
  createSelfCheckinResponsiveStyle({
    portrait: { borderRadius: 0 },
  }),
)

const labelStyle = css(
  {
    fontWeight: 'bold',
    fontSize: 20,
    color: '#272727',
    paddingBottom: 14,
    display: 'block',
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: FrontTabletResponsiveToken.formLabelFontSize.landscape13 },
  }),
)
const selectStyle = css(
  {
    width: '100%',
    height: '61px',
    fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape11,
    backgroundColor: '#fff',
    borderRadius: 40,
    padding: '0 35px 0 35px',
    appearance: 'none',
    backgroundImage: `url(${require('@/static/images/select.svg')})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '95% center',
    backgroundSize: 10,
    display: 'block',
    marginRight: 32,
    borderColor: '#CCCCCC',
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape13 },
  }),
)
